import { render, staticRenderFns } from "./HistoricStatusFilter.vue?vue&type=template&id=6bda5011&scoped=true&"
import script from "./HistoricStatusFilter.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./HistoricStatusFilter.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./HistoricStatusFilter.vue?vue&type=style&index=0&id=6bda5011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bda5011",
  null
  
)

export default component.exports